import React from 'react';
import './index.css';
import VerticalVector from "./VerticalVector";

function AllUsersPage(props) {
    return (
        <>
            <div
                className="flex flex-row rounded-[min(1vw,2vh)] justify-center items-center h-[min(5vw,10vh)] text-white my-[min(1vw,2vh)] bg-[#001037]">

                <div onClick={() => {props.changeTotalToEnteredAndBack(false, "all_user_grades")}}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] transition-all duration-400 cursor-pointer justify-center mr-[1%] border-[min(0.2vw,0.4vh)] border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[20%] h-[60%] bg-[#${props.situation.denominator === "total" ? "001037" : "4044ED"}]`}>

                    کاربران فعال
                    <img className="h-[70%] ml-[5%]" src={"https://uploads.zibazi.tv/site/assets/organ/dashboard/total1.png"} alt="icon"/>
                </div>
                <div onClick={() => {props.changeTotalToEnteredAndBack(true, "all_user_grades")}}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] transition-all duration-400 cursor-pointer justify-center ml-[1%] border-[min(0.2vw,0.4vh)] border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[20%] h-[60%] bg-[#${props.situation.denominator === "total" ? "4044ED" : "001037"}]`}>

                    کاربران وارد شده
                    <img className="h-[70%] ml-[5%]"  src={"https://uploads.zibazi.tv/site/assets/organ/dashboard/entered1.png"} alt="icon"/>
                </div>
            </div>
            <div
                className="flex flex-row w-full h-[min(40vw,80vh)] p-[min(1vw,2vh)] bg-[#001037] rounded-[min(1vw,2vh)] overflow-hidden justify-center items-center">
                <div className="flex flex-col h-full w-full">
                    <img className="relative top-[min(27.5vw,55vh)] w-full z-[1]"  src={"https://uploads.zibazi.tv/site/assets/organ/states/line.png"} alt="icon"/>
                    <div className="flex flex-row justify-center items-center h-[90%] mt-[1%] w-full z-[2]">
                        {props.grades.map((item, index) => (
                            index > 0 &&
                            <div className="flex flex-col-reverse h-[100%] w-[12%] justify-start items-center">
                                <div className="flex h-[100%] w-[60%] justify-center items-center h-[95%]">
                                    <VerticalVector grade={item[1]} denominator={props["stateData"]["grade"][props.situation.denominator][item[0]]} numerator={props["stateData"]["grade"][props.situation.numerator][item[0]]} color={props.grades[index][2]}/>
                                </div>
                            </div>
                        ))}
                        <div className="flex h-full text-[min(1.5vw,3vh)] justify-end items-end pr-[min(1vw,2vh)] flex-col text-white w-[24%]">
                            <div className="h-[min(3vw,6vh)] flex flex-row">
                                <span>{props.situation.denominator === "total" ? "کاربران وارد شده" : "کاربران فعال"}</span>
                                <img className="h-[80%] ml-[min(1vw,2vh)]" src="https://uploads.zibazi.tv/site/assets/organ/states/vector.png" alt="آیکون"/>
                            </div>
                            <div className="h-[min(3vw,6vh)] flex flex-row mt-[min(6vw,12vh)]">
                                <span>{props.situation.denominator === "total" ? "کاربران ثبت نامی" : "کاربران وارد شده"}</span>
                                <img className="h-[80%] ml-[min(1vw,2vh)] rotate-180" src="https://uploads.zibazi.tv/site/assets/organ/states/vector.png" alt="آیکون"/>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default AllUsersPage;